import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.2",
      d: "M12.928 5.8H10.2a.8.8 0 0 1-.8-.8V2.282M6.2 6.6l2 2-2 2"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.2",
      d: "M3.8 11v1.2a1.6 1.6 0 0 0 1.6 1.6h5.951c.874 0 1.587-.703 1.6-1.578L13 6.131a.8.8 0 0 0-.234-.565L9.635 2.434a.8.8 0 0 0-.566-.234H5.4a1.6 1.6 0 0 0-1.6 1.6v2.4M8 8.6H1.4"
    }, null, -1)
  ]))]))
}
export default { render: render }